module.exports = __webpack_public_path__ + "media/images/faramia/njs_title-d07dfcfa9c3c450154cd6be636fe78a2.png";